
import {
  DesignAttributeType
} from '../../../../types/designer-attribute-type';

import { BaseDesignerComponent } from '../../base/base-designer-component';
import { Component, ElementRef } from '@angular/core';

@Component({
  selector: 'sx-file-selector',
  templateUrl: './fileSelectorDesigner.component.html'
})
export class SxFileSelectorDesigner extends BaseDesignerComponent {

  constructor(container: ElementRef) {
    super(container, 'SxFileSelector');
  }

  loadDefaults(): void {
    super.loadDefaults();
    this.controlContext.label = 'FILE_SELECTOR';
    this.controlContext.isFoldedSelector = false;
  }

  getDesignerInfo(): any {
    const info = super.getDesignerInfo();
    info['label'] = this.controlContext.label;
    info['legend'] = this.controlContext.legend;
    info['isFoldedSelector'] =this.controlContext.isFoldedSelector;
    return info;
  }

  buildAttributes(): void {
    super.buildAttributes();
    const legend = new DesignAttributeType(this.controlContext, 'string', 'legend', 'LABEL');
    const label = new DesignAttributeType(this.controlContext, 'string', 'label', 'IDENTIFIER');
    const isFoldedSelector = new DesignAttributeType(this.controlContext, 'boolean', 'isFoldedSelector', 'FOLDED_SELECTOR');

    this.attributes.push(label);
    this.attributes.push(legend);
    this.attributes.push(isFoldedSelector);
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/files-manager/fileSelectorDesigner.component.ts